import { render } from "./Faqs.vue?vue&type=template&id=b48acd44&scoped=true&bindings={}"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"

import "./Faqs.vue?vue&type=style&index=0&id=b48acd44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b48acd44"

export default script